import {IStateCommonSub} from './reducer';
import {createActionFetch, createBasicActions} from '../../common/util/redux';
import {IUseTicketParams} from '../type';

export enum ActionType {
  SetValue = 'commonSub.SetValue',
  FetchEventPage = 'commonSub.FetchEventPage',
  FetchUseTicket = 'commonSub.FetchUseTicket',
  FetchTimeout = 'commonSub.FetchTimeout',
}

export const actions = {
  ...createBasicActions<IStateCommonSub>({
    setValueActionType: ActionType.SetValue,
  }),
  fetchEventPage: (payload: {htmlPath?: string; metaPath?: string}) =>
    createActionFetch(ActionType.FetchEventPage, {payload}),
  fetchTimeout: () => createActionFetch(ActionType.FetchTimeout),
  fetchUseTicket: (payload: IUseTicketParams) =>
    createActionFetch(ActionType.FetchUseTicket, {
      payload,
    }),
};
